import PropTypes from 'prop-types';
import React from 'react';

export class Paginator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inputPageNumber: 1,
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.currentPageNumber != this.state.inputPageNumber) {
      this.setState({ inputPageNumber: nextProps.currentPageNumber });
    }
  }

  onChange = (e) => {
    this.setState({ inputPageNumber: e.target.value });
  }

  onClickPrev = () => {
    if (!(this.props.currentPageNumber <= 1)) {
      this.setState({ inputPageNumber: this.state.inputPageNumber - 1 });
      this.props.onPageChange(this.props.currentPageNumber - 1);
    }
  }

  onClickNext = () => {
    if (!(this.props.currentPageNumber >= this.props.totalNumberOfPages)) {
      this.setState({ inputPageNumber: this.state.inputPageNumber + 1 });
      this.props.onPageChange(this.props.currentPageNumber + 1);
    }
  }

  onKeyPress = (e) => {
    if (e.key === 'Enter') {
      const value = e.target.value;
      if (!isNaN(value) && value >= 1 && value <= this.props.totalNumberOfPages) {
        this.setState({ inputPageNumber: e.target.value });
        this.props.onPageChange(parseInt(e.target.value, 10));
      } else {
        this.setState({ inputPageNumber: this.props.currentPageNumber });
      }
    }
  }

  render() {
    const { currentPageNumber, totalNumberOfPages } = this.props;
    return (
      <div className="multi-page-nav">
        <div className="row">
          <div className="col-sm-4 col-md-2 col-lg-4"></div>
          <div className="col-xs-12 col-sm-8 col-md-10 col-lg-8">
            <div className="col-xs-5 visible-xs-inline"></div>
            <button type="button"
              className="btn btn-link theme col-xs-3"
              onClick={ this.onClickPrev }
              disabled={ currentPageNumber <= 1}
            >
              <span className="glyphicon glyphicon-menu-left" />
            </button>
            <div className="col-xs-6 page-number hidden-xs">
              <input className="selected-page"
                type="text"
                value={ this.state.inputPageNumber }
                onChange={ this.onChange }
                onKeyPress={ this.onKeyPress }
              />
              {' / {0}'.replace('{0}', totalNumberOfPages)}
            </div>
            <button type="button"
              className="btn btn-link theme col-xs-3"
              onClick={ this.onClickNext }
              disabled={ currentPageNumber >= totalNumberOfPages }
            >
              <span className="glyphicon glyphicon-menu-right" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

Paginator.propTypes = {
  currentPageNumber: PropTypes.number,
  totalNumberOfPages: PropTypes.number,
  onPageChange: PropTypes.func,
};